import React from 'react'
import { ILinearProgress } from './interfaces'
import { StyledLinearProgress } from './style'

const LinearLoading: React.FC<ILinearProgress> = ({ width, height, display }) => {
  return <StyledLinearProgress display={display} width={width} height={height} />
}

export default LinearLoading
